(function(){
  const $ = (id) => document.getElementById(id);
  const money = (cents) => '₹' + (cents/100).toLocaleString('en-IN', {maximumFractionDigits:0});

  /* ---------- header scroll state ---------- */
  const header = document.querySelector('[data-header]');
  addEventListener('scroll', () => { if(header) header.classList.toggle('scrolled', scrollY > 8); });

  /* ---------- mobile menu ---------- */
  const burger = $('burgerBtn'), navLinks = $('navLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', () => navLinks.classList.toggle('mobile-open'));
  }

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  /* ---------- hero parallax ---------- */
  const heroInner = $('heroInner');
  if (heroInner) {
    const items = document.querySelectorAll('.collage');
    heroInner.addEventListener('mousemove', (e) => {
      const r = heroInner.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width/2) / r.width;
      const y = (e.clientY - r.top - r.height/2) / r.height;
      items.forEach(i => { const d = parseFloat(i.dataset.d || 12); i.style.transform = `translate(${x*d}px, ${y*d}px)`; });
    });
    heroInner.addEventListener('mouseleave', () => items.forEach(i => i.style.transform = ''));
  }

  /* ---------- mood tabs ---------- */
  document.querySelectorAll('.tabbar').forEach(bar => {
    bar.addEventListener('click', (e) => {
      const t = e.target.closest('.tab'); if (!t) return;
      bar.querySelectorAll('.tab').forEach(x => x.classList.toggle('active', x === t));
      const panels = bar.closest('section').querySelector('#tabPanels') || document.getElementById('tabPanels');
      panels.querySelectorAll('.tab-panel').forEach(p => p.classList.toggle('show', p.dataset.panel === t.dataset.mood));
    });
  });

  /* ---------- product rail carousels (works with multiple rails on the page) ---------- */
  document.querySelectorAll('.rail').forEach(rail => {
    const track = rail.querySelector('.rail-track');
    const prev = rail.querySelector('.rail-prev');
    const next = rail.querySelector('.rail-next');
    if (!track) return;
    const scrollStep = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 20 : 300) * 2;
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -scrollStep(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: scrollStep(), behavior: 'smooth' }));
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-q').forEach(b => b.addEventListener('click', () => {
    const it = b.parentElement, open = it.classList.contains('open');
    it.parentElement.querySelectorAll('.faq-item').forEach(x => x.classList.remove('open'));
    if (!open) it.classList.add('open');
  }));

  /* ---------- countdown ---------- */
  const cd = $('countdown');
  if (cd) {
    const end = new Date(cd.dataset.end).getTime() || (Date.now() + 3*864e5);
    setInterval(() => {
      const d = Math.max(0, end - Date.now());
      const p = n => String(n).padStart(2, '0');
      if ($('cdD')) $('cdD').textContent = p(Math.floor(d / 864e5));
      if ($('cdH')) $('cdH').textContent = p(Math.floor(d / 36e5) % 24);
      if ($('cdM')) $('cdM').textContent = p(Math.floor(d / 6e4) % 60);
      if ($('cdS')) $('cdS').textContent = p(Math.floor(d / 1e3) % 60);
    }, 1000);
  }

  /* ---------- wishlist (localStorage) ---------- */
  const WKEY = 'celestria_wishlist';
  let wish = new Set(JSON.parse(localStorage.getItem(WKEY) || '[]'));
  function saveWish() {
    localStorage.setItem(WKEY, JSON.stringify([...wish]));
    document.querySelectorAll('#wishCount').forEach(n => n.textContent = wish.size);
  }
  function paintWish() {
    document.querySelectorAll('[data-wish]').forEach(btn => btn.classList.toggle('on', wish.has(btn.dataset.wish)));
  }
  saveWish(); paintWish();

  /* ---------- saved items drawer ---------- */
  function openWish() { renderWishUI(); $('wishDrawer') && $('wishDrawer').classList.add('on'); $('wishScrim') && $('wishScrim').classList.add('on'); }
  function closeWish() { $('wishDrawer') && $('wishDrawer').classList.remove('on'); $('wishScrim') && $('wishScrim').classList.remove('on'); }
  function renderWishUI() {
    const body = $('wishBody');
    if (!body) return;
    const handles = [...wish];
    if (!handles.length) {
      body.innerHTML = '<p class="dr-empty">Nothing saved yet. Tap the heart on anything you love.</p>';
      return;
    }
    body.innerHTML = '<p class="dr-empty">Loading…</p>';
    Promise.all(handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))
      .then(products => {
        const valid = products.filter(Boolean);
        if (!valid.length) { body.innerHTML = '<p class="dr-empty">Nothing saved yet. Tap the heart on anything you love.</p>'; return; }
        body.innerHTML = valid.map(p => {
          const variant = p.variants[0];
          const img = p.featured_image;
          return `
        <div class="ci" data-handle="${p.handle}">
          <a href="${p.url}" class="ci-th">${img ? `<img src="${img}" alt="" style="width:100%;height:100%;object-fit:cover;">` : '<svg viewBox="0 0 120 120"><use href="#a-ring"/></svg>'}</a>
          <div class="ci-info">
            <a href="${p.url}"><b>${p.title}</b></a><small>${money(variant.price)}</small>
            <div class="qty">
              <button data-add="${variant.id}" class="btn" style="padding:6px 12px;font-size:.66rem;">Add to bag</button>
            </div>
          </div>
          <button data-wish-rm="${p.handle}" aria-label="Remove">✕</button>
        </div>`;
        }).join('');
      });
  }
  $('wishBtn') && ($('wishBtn').onclick = openWish);
  $('mWish') && $('mWish').addEventListener('click', e => { e.preventDefault(); openWish(); });
  $('wishClose') && ($('wishClose').onclick = closeWish);
  $('wishScrim') && ($('wishScrim').onclick = closeWish);

  /* ---------- Shopify AJAX cart ---------- */
  function renderCartUI(cartData) {
    const body = $('drBody');
    if (!body) return;
    if (!cartData.items.length) {
      body.innerHTML = '<p class="dr-empty">Your bag is empty. Pick something quiet.</p>';
    } else {
      body.innerHTML = cartData.items.map(item => `
        <div class="ci" data-key="${item.key}">
          <span class="ci-th">${item.image ? `<img src="${item.image}" alt="" style="width:100%;height:100%;object-fit:cover;">` : '<svg viewBox="0 0 120 120"><use href="#a-ring"/></svg>'}</span>
          <div class="ci-info">
            <b>${item.product_title}</b><small>${money(item.final_price)}</small>
            <div class="qty">
              <button data-dec="${item.key}">−</button><span>${item.quantity}</span><button data-inc="${item.key}">+</button>
            </div>
          </div>
          <button data-rm="${item.key}" aria-label="Remove">✕</button>
        </div>`).join('');
    }
    if ($('drSub')) $('drSub').textContent = money(cartData.total_price);
    const freeShip = cartData.total_price >= 99900;
    if ($('drShip')) $('drShip').textContent = cartData.total_price === 0 ? '—' : (freeShip ? 'Free' : money(9900));
    if ($('drTotal')) $('drTotal').textContent = money(cartData.total_price + (freeShip || cartData.total_price === 0 ? 0 : 9900));
    document.querySelectorAll('#cartCount').forEach(n => n.textContent = cartData.item_count);
  }

  function fetchCart() { return fetch('/cart.js').then(r => r.json()); }
  function refreshCart() { fetchCart().then(renderCartUI); }

  function addToCart(variantId, properties) {
    const payload = { items: [{ id: variantId, quantity: 1 }] };
    if (properties) payload.items[0].properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(r => r.json()).then(() => refreshCart());
  }

  function changeQty(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json()).then(renderCartUI);
  }

  function openDrawer() { $('drawer') && $('drawer').classList.add('on'); $('scrim') && $('scrim').classList.add('on'); }
  function closeDrawer() { $('drawer') && $('drawer').classList.remove('on'); $('scrim') && $('scrim').classList.remove('on'); }
  $('cartBtn') && ($('cartBtn').onclick = openDrawer);
  $('drClose') && ($('drClose').onclick = closeDrawer);
  $('scrim') && ($('scrim').onclick = closeDrawer);
  $('mCart') && $('mCart').addEventListener('click', e => { e.preventDefault(); openDrawer(); });

  document.body.addEventListener('click', (e) => {
    const add = e.target.closest('[data-add]');
    if (add) {
      const variantId = add.dataset.add;
      const original = add.textContent;
      addToCart(variantId).then(() => { add.textContent = 'Added ✓'; openDrawer(); setTimeout(() => add.textContent = original, 1100); });
      return;
    }
    const wrm = e.target.closest('[data-wish-rm]');
    if (wrm) {
      wish.delete(wrm.dataset.wishRm);
      saveWish(); paintWish(); renderWishUI();
      return;
    }
    const w = e.target.closest('[data-wish]');
    if (w) {
      const id = w.dataset.wish;
      wish.has(id) ? wish.delete(id) : wish.add(id);
      saveWish(); paintWish();
      return;
    }
    const inc = e.target.closest('[data-inc]');
    if (inc) { fetchCart().then(c => { const item = c.items.find(i => i.key === inc.dataset.inc); changeQty(inc.dataset.inc, item.quantity + 1); }); return; }
    const dec = e.target.closest('[data-dec]');
    if (dec) { fetchCart().then(c => { const item = c.items.find(i => i.key === dec.dataset.dec); changeQty(dec.dataset.dec, Math.max(0, item.quantity - 1)); }); return; }
    const rm = e.target.closest('[data-rm]');
    if (rm) { changeQty(rm.dataset.rm, 0); return; }
    const q = e.target.closest('[data-quick]');
    if (q) { openQuickView(q.dataset.handle); return; }
  });

  /* ---------- quick view ---------- */
  function openQuickView(handle) {
    fetch(`/products/${handle}.js`).then(r => r.json()).then(p => {
      const variant = p.variants[0];
      $('qvVis').innerHTML = p.featured_image
        ? `<img src="${p.featured_image}" alt="" style="width:100%;height:auto;">`
        : `<svg viewBox="0 0 120 120"><use href="#a-ring"/></svg>`;
      $('qvKr').textContent = '';
      $('qvName').textContent = p.title;
      $('qvDesc').innerHTML = p.description ? p.description.replace(/<[^>]*>/g, '').slice(0, 220) : '';
      $('qvNow').textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        $('qvWas').textContent = money(variant.compare_at_price);
        $('qvOff').textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + '% off';
      } else { $('qvWas').textContent = ''; $('qvOff').textContent = ''; }
      $('qvAdd').onclick = () => { addToCart(variant.id).then(() => { closeQV(); openDrawer(); }); };
      $('qv').classList.add('on');
      $('qvScrim') && $('qvScrim').classList.add('on');
    });
  }
  function closeQV() { $('qv') && $('qv').classList.remove('on'); $('qvScrim') && $('qvScrim').classList.remove('on'); }
  $('qvClose') && ($('qvClose').onclick = closeQV);
  $('qvScrim') && ($('qvScrim').onclick = closeQV);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeQV(); closeDrawer(); closeWish(); } });

  /* ---------- product page variant -> hidden input sync ---------- */
  document.querySelectorAll('.variant-select').forEach(sel => {
    sel.addEventListener('change', () => {
      // Simple sync: relies on Shopify's product form to resolve variant server-side on submit
      // For full variant-matrix logic, extend with product.variants JSON if needed.
    });
  });

  refreshCart();
})();